import Spinner from './Spinner'
import './Spinner.css'

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js